/* eslint-disable @typescript-eslint/naming-convention */

export enum AdminRoleTypeEnum {
  ADMIN = 'admin',
  SUPER_ADMIN = 'super-admin',
}
